import CatalogItem from "@components/Actions/CatalogItems/Base";
import Icon from "@components/Atoms/Icon";
import { CATALOG_REPORT_PANEL_ID } from "@ext/catalog/report/models/consts";
import t from "@ext/localization/locale/translate";
import { usePanelToggle } from "@ui-kit/FloatingPanel";
import type { ReactNode } from "react";

interface ReportItemProps {
	children?: ReactNode;
}

const ReportItem = ({ children }: ReportItemProps) => {
	const { toggle } = usePanelToggle(CATALOG_REPORT_PANEL_ID);

	return (
		<CatalogItem
			renderLabel={(Item) => (
				<Item onSelect={toggle}>
					<Icon code="chart-no-axes-column" />
					{t("catalog.report.name")}
				</Item>
			)}
		>
			{children}
		</CatalogItem>
	);
};

export default ReportItem;
